import Vue from 'vue';
import loadingTemplate from "components/layouts/loaders/cube_loading";

export default Vue.extend({
 template: '' +
  '<div class = "ag-overlay-loading-center">' +
  '<loadingTemplate></loadingTemplate>' +
  '<h5 class="ag-overlay-message">{{params.loadingMessage}}</h5>' +
  '</div>',
 components: {
  loadingTemplate
 }
});
